import { render } from "./MenuProfile.vue?vue&type=template&id=2a88b67e&scoped=true"
import script from "./MenuProfile.vue?vue&type=script&lang=js"
export * from "./MenuProfile.vue?vue&type=script&lang=js"

import "./MenuProfile.vue?vue&type=style&index=0&id=2a88b67e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a88b67e"]])

export default __exports__